import React, { useState } from 'react'
import Barcode from '../../../common/images/Barcode.png';
import ShareIcon from '../../assets/icons/ShareIcon';
import DownloadIcon from '../../assets/icons/DownloadIcon';
import PrintIcon from '../../assets/icons/PrintIcon';
import { Link, useLocation } from 'react-router-dom';
import html2canvas from 'html2canvas';
import { useTranslation } from 'react-i18next';
import RightArrow from 'admin/common/icons/right-arrow';
import Location from 'admin/common/icons/sidebar/Location';
import './appointment.scss'
import GreenTick from 'admin/common/icons/GreenTick';
import Calendar from 'admin/common/icons/sidebar/Calendar';
import BottomBar from 'Ecommerce/template_four/include/Common/BottomBar';
const AppointmentConfirm = (props) => {
    const {websiteinfo} = props;
    console.log('propss',props)
    const { state } = useLocation()
    const { t } = useTranslation();
    const [appoinmentconfirm, setappoinmentconfirm] = useState(true)

    const downloadPageAsPNG = () => {
        const rootElement = document.getElementById('appoinmentdata');
        html2canvas(rootElement).then((canvas) => {
            const imageURL = canvas.toDataURL(`image/png`);
            const anchor = document.createElement('a');
            anchor.download = `${state?.appointment_id}.png`;
            anchor.href = imageURL;
            anchor.click();
        });
    };
    const handlePrint = () => {
        window.print();
        setappoinmentconfirm(false);
    };
    return (
        <div className='bookappointmentpage' id='appoinmentdata'>
            <div className='bookappointmentpage-header'>
                <span className=''>{t("Home")}</span>
                <span className='SlashPath'><RightArrow /></span>
                <span className='text'>{t("Book an Appointment")}</span>
            </div>
            <div className='bookappointment_confirm-main mx-auto'>
                <div className='bookappointment_confirm-main-title'>{t("Book an Appointment")}</div>
                <div className='bookappointment_confirm-main-successbar'><span>{t("Your Appointment Has Been Confirmed")}</span><span><GreenTick color="#ffffff" /></span></div>
                <div className='bookappointment_confirm-main-containerBox-getDocsIconBox'>
                    <span className='bookappointment_confirm-main-containerBox-getDocsIconBox-Iconspan'><ShareIcon /></span>
                    <span className='bookappointment_confirm-main-containerBox-getDocsIconBox-Iconspan' onClick={() => downloadPageAsPNG()}><DownloadIcon /></span>
                    <span className='bookappointment_confirm-main-containerBox-getDocsIconBox-Iconspan'
                        onClick={() => handlePrint()}><PrintIcon /></span>
                </div>
                <div className='bookappointment_confirm-main-containerBox-logoBox' >
                    <img src={websiteinfo?.websiteInfo?.logo} alt='logo' />
                </div>
                <div className='bookappointment_confirm-main-headerBox'>
                    <h3 className='bookappointment_confirm-main-headerBox-thankYouText'>{t("Appointment ID")}: #{state?.appointment_id}</h3>
                </div>
                <div className='bookappointment_confirm-main-containerBox'>

                    <div className='bookappointment_confirm-main-containerBox-middleContentBox'>
                        {/* <div className='bookappointment_confirm-main-containerBox-middleContentBox-purchaseIdBox'>
                            <span className='idShows'>{t("Appointment ID")} : #{state?.appointment_id}</span> 
                            <span onClick={() => handleCopyClick(state?.appointment_id)}><CartIcon widt={'19px'} height={'19px'} /></span> 
                        </div> 
                        <span className='text-center'>{showstatus ? t("Copy Successfully") : ""} </span>*/}

                    </div>
                    <div className='bookappointment_confirm-main-containerBox-allshippingAddrShow'>
                        <div className="addressShowBox bookappointment_confirm-main-containerBox-allshippingAddrShow-singleShippAddr">
                            <div className="addressShowBox-headerBox">
                                <h2 className='shippingaddrHeader'>{t("Appointment Date")}</h2>
                                <h3 className="shippingaddrHeaderright">
                                    {state?.appointment_date} <span className='time'>{state?.time}</span>
                                </h3>
                            </div>
                            <div className='addressShowBox-holder'>
                                <h3 className="addressShowBox-AddrparaBox fw-normal">
                                    <div className='addressShowBox-AddrparaBox-title'>{t("purpose of your visit")}</div>
                                    <div className='addressShowBox-AddrparaBox-content'>{state?.appointmentDetails?.name}</div>
                                </h3>
                                <h3 className="addressShowBox-AddrparaBox fw-normal">
                                    <div className='addressShowBox-AddrparaBox-title'>{t("Location")}</div>
                                    <div className='addressShowBox-AddrparaBox-content'>{state?.branchDetails?.name}<br />
                                        <span><Location color="#767676" width="11px" height="15px" />{state?.branchDetails?.store_Address}</span>
                                    </div>
                                </h3>
                                <p className="addressShowBox-AddrparaBox w-100 fw-normal">
                                    <div className='addressShowBox-AddrparaBox-title'>{t("Customer")}</div>
                                    <div className='addressShowBox-AddrparaBox-content'>{state?.appointmentDetails?.name}</div>
                                </p>
                                <p className="addressShowBox-AddrparaBox w-100 fw-normal">
                                    <div className='addressShowBox-AddrparaBox-title'>{t("Phone")}</div>
                                    <div className='addressShowBox-AddrparaBox-content'>{state?.appointmentDetails?.contact}</div>
                                </p>
                                <p className="addressShowBox-AddrparaBox">
                                    <div className='addressShowBox-AddrparaBox-title'>{t("Email")}</div>
                                    <div className='addressShowBox-AddrparaBox-content'>{state?.appointmentDetails?.email}</div>
                                </p>
                                <p className="addressShowBox-AddrparaBox">
                                    <div className='addressShowBox-AddrparaBox-title'>{t("Status")}</div>
                                    <div className='addressShowBox-AddrparaBox-content'>{state?.appointmentDetails?.contact}</div>
                                </p>
                            </div>
                        </div>
                        {/* <div className="addressShowBox bookappointment_confirm-main-containerBox-allshippingAddrShow-singleShippAddr">
                            <div className="addressShowBox-headerBox">
                                <h2 className='shippingaddrHeader'>{t("Appointment branch")}</h2>
                            </div>
                            <div className='d-flex flex-column'>
                                <h3 className="addressShowBox-AddrparaBox ">
                                    
                                </h3>
                                <p className="addressShowBox-AddrparaBox w-100 ">
                                    {state?.branchDetails?.store_Address}
                                </p>
                                <p className="addressShowBox-AddrparaBox w-100">
                                    {state?.branchDetails?.email}
                                </p>
                                <p className="addressShowBox-phonePara mt-1">
                                    
                                </p>
                            </div>
                            <div className='mt-1 d-flex flex-column gap-2 w-100'>
                                <p className="addressShowBox-AddrparaBox" >{t("Store Hours")}</p>
                                <div className='w-100 justify-content-start addressShowBox-daytimeSet'>
                                    {Object.keys(state?.branchDetails?.store_timeSchedule || {}).map((key) => (
                                        <div className='addressShowBox-daytimeSet-singleDay' key={key}>
                                            <p className='addressShowBox-phonePara addressShowBox-daytimeSet-singleDay-day'>{key}</p>
                                            <p className='addressShowBox-phonePara addressShowBox-daytimeSet-singleDay-time'>{state?.branchDetails?.store_timeSchedule[key]}</p>
                                        </div>
                                    ))}
                                </div>

                            </div>
                        </div> */}
                    </div>
                    <div className='bookappointment_confirm-main-containerBox-middleContentBox-barbox'><img alt='barcode' src={state?.appointmentDetails?.Barcode ? state?.appointmentDetails?.Barcode : Barcode} /></div>


                    <div className='bookappointment_confirm-main-containerBox-impmsg'>
                        <span className="tag">{t("Message From Business")}</span>
                        <div className='bookappointment_confirm-main-containerBox-impmsg-thanksParaBox'>{t("Please arrive 15 minutes early for your appointment. Thank you.")}.</div>
                    </div>

                </div>
                {appoinmentconfirm ?
                    <div className='bookappointment_confirm-main-footerBox'>
                        <Link className='bookappointment_confirm-main-footerBox-continueShopBtn d-flex justify-content-center align-items-center text-decoration-none' to="/appointment"><Calendar withclock="true" /> <span> {t("Book New Appointment")}</span></Link>
                        <Link className='bookappointment_confirm-main-footerBox-completeBtn' to="/collection">{t("Continue Shopping")}</Link>
                    </div> : ""}
            </div>
            <BottomBar />
        </div>
    )
}

export default AppointmentConfirm